import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  let has_admin = useDataValue({
    viewPath: props.viewPath,
    context: 'global',
    path: 'current_location.permissions.has_admin',
  })

  let location_id = useDataValue({
    context: 'global',
    path: 'current_location._id',
    viewPath: props.viewPath,
  })

  let user_id = useDataValue({
    context: 'global',
    path: 'user.id',
    viewPath: props.viewPath,
  })

  let list_type = useDataValue({
    context: 'task_boards_list',
    path: 'type',
    viewPath: props.viewPath,
  })

  // my boards - all I'm subscribed to, except my own private one.
  let boardsWhere = {
    subscribers: { user_id: { _eq: user_id } },
    _or: [{ created_by: { _neq: user_id } }, { type: { _neq: 'PRIVATE' } }],
  }

  if (list_type === 'other-boards') {
    let type = { _eq: 'PUBLIC' }
    if (has_admin) {
      type = { _in: ['PUBLIC', 'HIDDEN'] }
    }

    boardsWhere = {
      type: type,
      _not: { subscribers: { user_id: { _eq: user_id } } },
    }
  } else if (list_type === 'private') {
    boardsWhere = { type: { _eq: 'PRIVATE' }, created_by: { _eq: user_id } }
  }

  return {
    variables: {
      location_id,
      user_id,
      boards_where: boardsWhere,
    },
  }
}
